import { render, staticRenderFns } from "./Sidebar.vue?vue&type=template&id=a2a73242&scoped=true"
import script from "./Sidebar.vue?vue&type=script&lang=js"
export * from "./Sidebar.vue?vue&type=script&lang=js"
import style0 from "./Sidebar.vue?vue&type=style&index=0&id=a2a73242&prod&lang=scss"
import style1 from "./Sidebar.scss?vue&type=style&index=1&id=a2a73242&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2a73242",
  null
  
)

export default component.exports